import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiInfo } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/icon.svg" alt="Tap2Order" className="h-8 w-8" />
              <span className="text-xl font-bold text-white">Tap2Order</span>
            </div>
            <div className="space-y-2 text-sm">
              <p className="text-white font-semibold">
                Tap2Order © 2026 di Dynamic-Web Srls
              </p>
              <p>P.Iva 03034040356 – Tutti i diritti sono riservati</p>
              <p className="text-gray-400">
                <span className="font-medium">Rag. Sociale:</span> DYNAMIC-WEB SRLS - SOCIETÀ A RESPONSABILITÀ LIMITATA SEMPLIFICATA
              </p>
            </div>
          </div>

          {/* Privacy & Security */}
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <SafeIcon icon={FiShield} className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="text-white font-medium mb-2">Privacy & Sicurezza</h3>
                <p className="text-sm text-gray-400 leading-relaxed">
                  Questa applicazione funziona completamente in locale, senza inviare o 
                  condividere dati con server esterni.
                </p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <SafeIcon icon={FiInfo} className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="text-white font-medium mb-2">Sistema di Gestione Ristorante</h3>
                <p className="text-sm text-gray-400 leading-relaxed">
                  Soluzione completa per la gestione di ordini, menù, cucina, cassa e statistiche.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-500">
              Sviluppato con tecnologie moderne per garantire prestazioni e affidabilità
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <span>React</span>
              <span>•</span>
              <span>PocketBase</span>
              <span>•</span>
              <span>Tailwind CSS</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;